<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor } from '@/utils/modules/getStyles'
import { filtersRichtext, textLenHandler } from '@/utils/common'

export default {
  name: 'Comp51',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: {
    getShadowColor, filtersRichtext, textLenHandler
  }
}
</script>

<template>
  <div class="modules-id-51">
    <module-title :title="moduleOption.title" margin-bottom="20" />
    <div class="comp-transverse-2 modules-id-51-content">
      <div
        v-for="(v, i) in moduleOption.list.slice(0, 4)"
        :key="`modules-id-51-item-${i}`"
        class="item"
        :class="`item-${i + 1}`"
      >
        <p class="item-memo h-line-1">“{{ v.memo }}”</p>
        <p class="item-name h-line-1">——{{ v.name }}</p>
      </div>
      <el-image class="img-bird" :src="require('imgs/modules/comp51-bg-bird.png')" />
      <el-image class="img-house" :src="require('imgs/modules/comp51-bg-house.png')" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-51-content {
  width: 717px;
  height: 337px;
  padding:  0 0 0 30px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  .img-bird {
    width: 101px;
    height: 114px;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 8;
  }
  .img-house {
    width: 191px;
    height: 114px;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 8;
  }
  .item {
    width: 294px;
    height: 108px;
    background: url('~imgs/modules/comp51-bg-l.png') no-repeat center;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .item-memo {
      width: 220px;
      font-size: 11px;
      font-family: siyuansong;
      color: #F78307;
      margin-top: 12px;
    }
    .item-name {
      width: 211px;
      font-size: 10px;
      font-family: siyuansong;
      color: #F78307;
      text-align: end;
      margin-top: 12px;
    }
  }
  .item:nth-child(even) {
    background: url('~imgs/modules/comp51-bg-r.png') no-repeat center;
    background-size: 100% 100%;
  }
  .item-1 {
    margin: 38px 0 0 120px;
    z-index: 5;
  }
  .item-2 {
    position: absolute;
    top: 100px;
    right: 42px;
    z-index: 6;
  }
  .item-3 {
    position: absolute;
    top: 135px;
    left: 52px;
    z-index: 4;
  }
  .item-4 {
    position: absolute;
    top: 200px;
    right: 120px;
    z-index: 7;
  }
}
</style>
